module.exports = __webpack_public_path__ + "static/media/md-remove-circle.173207ee.svg";